
<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0">Credit Application</h3>
    <b-row>
      <b-col cols="12">
        <div v-if="_gAuth.isAppSas()">
          <div v-if="safeCreditApplication.length > 0" class="rounded-bottom">
            <el-table :data="safeCreditApplication" style="width: 100%">
              <!-- Custom column with date above and facility below -->
              <el-table-column
                min-width="210"
                width="auto"
                label="Date / Facility"
              >
                <template slot-scope="scope">
                  <div>
                    <div>{{ scope.row.c_date }}</div>
                    <small class="text-muted">{{ scope.row.c_facility }}</small>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="unit"
                min-width="210"
                width="auto"
                label="Unit (RM)"
              />
              <el-table-column
                prop="status"
                min-width="210"
                width="auto"
                label="Status"
              />
            </el-table>
          </div>

          <div v-else class="bg-light p-3 text-center rounded-bottom">
            <p class="text-xs">No Credit Applications recorded</p>
          </div>
        </div>

        <!-- Non-SAS App -->
        <div v-else>
          <table class="credit-application-table">
            <thead>
              <!-- <tr class="section-header">
                <th colspan="9">Credit Application</th>
              </tr> -->
              <tr>
                <th>Date</th>
                <th>Sts</th>
                <th>Capacity</th>
                <th>Lender</th>
                <th>Facility / App Type</th>
                <th>Instl Amt (RM)</th>
                <th colspan="3"></th>
              </tr>
            </thead>
            <tbody v-if="creditApplication && creditApplication.length > 0">
              <template v-for="(item, index) in creditApplication">
                <!-- Main record row -->
                <tr :key="'group-main-' + index">
                  <td>{{ item.c_date }}</td>
                  <td>{{ item.c_status }}</td>
                  <td>{{ item.c_capacity }}</td>
                  <td>{{ item.c_lender_type }}</td>
                  <td>
                    <div>{{ item.c_facility }}</div>
                    <small class="text-muted">{{ item.application_type }}</small>
                  </td>
                  <td>{{ formatAmount(item.c_amount) }}</td>
                  <td colspan="3"></td>
                </tr>
                <!-- Property details row - now under each record -->
                <tr :key="'group-prop-' + index">
                  <td colspan="6">
                    <strong>Property Address:</strong>
                    <span class="text-muted ml-2">{{ item.property_address || '&nbsp;' }}</span>
                  </td>
                  <td colspan="3">
                    <strong>Property Status:</strong>
                    <span class="text-muted ml-2">{{ item.property_status || '&nbsp;' }}</span>
                  </td>
                </tr>
              </template>
            </tbody>

            <tbody v-else>
              <tr>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>
                  <div>-</div>
                  <small class="text-muted">-</small>
                </td>
                <td>-</td>
                <td colspan="3"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "CreditApplicationModal",
  props: {
    creditApplication: {
      type: Array,
      default: () => [],
    },
    show_credit_app_full_view: Boolean,
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    show: {
      get() {
        return this.show_credit_app_full_view;
      },
      set(value) {
        this.$emit("update:show_credit_app_full_view", value);
      },
    },
    // safeCreditApplication() {
    //   if (!this.creditApplication) return []

    //   return this.creditApplication.map(item => {
    //     // Normalize the amount
    //     let amount = parseFloat(item.c_amount)
    //     const formattedAmount = isNaN(amount)
    //     ? ''
    //     : 'RM ' + amount.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

    //     // map statuses same as in card
    //     let status = item.c_status
    //     if (this._gAuth.isAppSas()) {
    //       if (status === 'Approved by FI') status = 'A'
    //       else if (status === 'Pending decision by FI') status = 'P'
    //     }

    //     return {
    //       c_date: item.c_date || '',
    //       c_facility: item.c_facility || '',
    //       unit: formattedAmount,
    //       status
    //     }
    //   })
    // }
  safeCreditApplication() {
      if (!this.creditApplication) return [];

      return this.creditApplication.map((item) => {
        let amount = parseFloat(item.c_amount);
        const formattedAmount = isNaN(amount)
          ? ""
          : "RM " +
            amount.toLocaleString("en-MY", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });


        let status = item.c_status;
        if (status.toLowerCase() === "approved by fi") status = "A";
        else if (status.toLowerCase().includes("pending decision by fi")) status = "P";
        return {
          c_date: item.c_date || "",
          c_facility: item.c_facility || "",
          unit: formattedAmount,
          status,
          property_address: item.property_address || "",
          property_status: item.property_status || "",
        };
      });
    },
  },

  methods: {
    /** Format a number as RM currency with 2 decimals **/
    formatAmount(amount) {
      const num = parseFloat(amount);
      if (isNaN(num)) return "";
      return "RM " + num.toLocaleString("en-MY", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>
<style scoped>
.credit-application-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: 20px;
}

.credit-application-table th,
.credit-application-table td {
  border: 1px solid #c1c1c1;
  padding: 6px 8px;
  text-align: left;
  vertical-align: top;
  white-space: nowrap;
}

/* New header styling for the main table headers */
.credit-application-table thead tr:not(.section-header) th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
  text-align: center !important;
}

/* Section header styling (keep original for the title row) */
.credit-application-table .section-header th {
  /* background-color: #b3b6b3; */
  text-align: left;
  font-weight: bold;
  /* border: 1px solid #c1c1c1; */
  border: none !important;
  color: #000 !important;
  padding: 9px 12px;
}

.credit-application-table td[colspan="9"] {
  background-color: #f9f9f9;
}

/* Optional: Add some visual separation between record groups */
.credit-application-table tbody tr:nth-child(odd) {
  background-color: #fafafa;
}

.credit-application-table tbody tr:nth-child(even) {
  background-color: #ffffff;
}
</style>